'use strict';
const urlHelper = require('core/helpers/urlHelper');

const fyobManager = {
    boxArr: [],
    boxAmountOfIrresistibles: null,
    maxAmountOfPralinesPerBox: null,
    filterArr: [],
    isMobile() {
        return window.matchMedia('only screen and (max-width: 960px)').matches;
    },
    /**
     * gets the amount of max irrestibles in box
     */
    getIrresistiblesAmount() {
        const boxAmountOfIrresistibles = parseInt($('.js-selected-box').data('irresistibles-amount'), 10);
        this.boxAmountOfIrresistibles = boxAmountOfIrresistibles || null;
    },
    /**
     * gets the amount of max pralines in box
     */
    getAmountOfPralinesPerBox() {
        this.maxAmountOfPralinesPerBox = parseInt($('.js-selected-box').data('box-size'), 10);
    },
    /**
     * adds data to the next place in the box array
     * @param {Object} data product data
     */
    pushDataIntoArray(data) {
        this.boxArr.push(data);
    },
    /**
     *  shows remove button
     * @param {number} boxPlace shows remove button based on place in box
     */
    showRemoveButton(boxPlace) {
        $('.js-close-selected[data-box-place="' + boxPlace + '"]').removeClass('d-none');
    },
    /**
     * hides all remove buttons
     */
    hideRemoveButton() {
        $('.js-close-selected').addClass('d-none');
    },
    /**
    * builds the selected praline from the box
    * @param {Object} productData product data of praline
    * @param {number} index place of praline in array corresponding to grid
    */
    buildSelctedBoxSpot(productData, index) {
        const $boxPlaceSelector = $('.js-selected-' + index);

        $boxPlaceSelector.addClass('is-filled')
            .attr('data-pid', productData.pid)
            .attr('data-arr-row', productData.row)
            .attr('data-arr-col', productData.col)
            .addClass('animate-width');
        // $boxPlaceSelector.find('.js-single-praline-name').empty().append(productData.productName);
        $boxPlaceSelector.find('.js-grid-single-praline-image').attr('src', productData.productImage).removeClass('d-none');
        this.showRemoveButton(index);
    },
    /**
     * gets the amount of columns in the box
     * @returns {number} amount of columns in the box
     */
    getAmountOfCol() {
        return $('.js-custom-grid').data('columns');
    },
    /**
     * gets the amount of rows in the box
     * @returns {number} amount of rows in the box
     */
    getAmountOfRow() {
        return $('.js-custom-grid').data('rows');
    },
    /**
     * rebuilds box grid based on the array
     */
    buildBoxGridBasedOnArray() {
        this.boxArr.forEach((box, index) => {
            this.buildSelctedBoxSpot(box, index);
        });
    },
    /**
     * rearranges the entire grid when praline is removed
     */
    clearBoxgrid() {
        const allFilledSpot = $('.js-selected-content[data-pid]');

        allFilledSpot.each((index, element) => {
            const $this = $(element);
            const $imageSelector = $this.find('.js-grid-single-praline-image');

            $this.attr('data-pid', '')
                .removeClass('is-filled')
                .removeClass('animate-width');
                // .find('.js-single-praline-name')
                // .empty();

            $imageSelector.attr('src', '')
                .addClass('d-none');

            this.hideRemoveButton(index + 1);
        });
    },
    /**
     * removes praline from the array(box)
     * @param {number} index index
     */
    removeDataFromArray(index) {
        this.boxArr.splice(index, 1);
    },
    /**
     * gets the amount of irrestibles in the box
     * @returns {number} amount of irrestibles
     */
    getAmountOfIrresistiblesInBoxArr() {
        return this.boxArr.reduce((count, product) => {
            return product.productWeight === 3 ? count + 1 : count;
        }, 0);
    },
    /**
     * removes the disabled spot in the box(cross) for irrestibles
     */
    removeDisabledspots() {
        const amountIrresistibles = this.getAmountOfIrresistiblesInBoxArr();
        const amountOfDisabledSpots = $('.js-selected-content.disabled').length;
        if (amountIrresistibles % this.boxAmountOfIrresistibles === 0) {
            if (amountIrresistibles === 0 || (amountIrresistibles / this.boxAmountOfIrresistibles) < amountOfDisabledSpots) {
                $('.js-selected-content.disabled').first().removeClass('disabled');
            }
        }
    },
    /**
     * removes the selected praline from the box
     * @param {number} boxPlace place of the item in the box grid
     */
    removeSelectedBoxSpot(boxPlace) {
        $.spinner().start();

        this.removeDataFromArray(boxPlace);
        this.hideRemoveButton(boxPlace);
        this.clearBoxgrid();
        this.buildBoxGridBasedOnArray();
        if (this.pralinesAreDisable() && this.boxArr.length < this.maxAmountOfPralinesPerBox) {
            this.enableAddPralines();
        }
        this.checkToDisableOrEnablePralines();
        this.disableProceedButton();
        this.removeDisabledspots();
        $.spinner().stop();
    },
    productSearch(searchTerm, products) {
        products.each(function (index, product) {
            const productName = $(product).data('product-name').toLowerCase();
            if (!productName.includes(searchTerm.toLowerCase())) {
                $(product).addClass('d-none').removeClass('d-flex');
            } else {
                $(product).addClass('d-flex').removeClass('d-none');
            }
        });
    },
    productRemainingMsg() {
        if ($('.js-praline-selector.d-flex').length === 0) {
            $('.js-no-products').removeClass('d-none');
        } else if ($('.js-praline-selector.d-flex').length > 0 && $('.js-no-products:not(.d-none)')) {
            $('.js-no-products').addClass('d-none');
        }
    },
    /**
     * gets the amount of cornets in the box
     * @returns {number} amount of cornets in the box
     */
    getAmountOfCornetsInBoxArr() {
        return this.boxArr.reduce((count, product) => {
            return product.productWeight === 2 ? count + 1 : count;
        }, 0);
    },
    /**
     * disable pralines based on praline type/weight
     * @param {Array} excludedPraline array of praline types to NOT disbaled
     */
    disableAddPralines(excludedPraline) {
        let selectorString = '.js-praline-selector';
        if (excludedPraline && excludedPraline.length) {
            selectorString += `:not([data-praline-weight="${excludedPraline.join('"]):not([data-praline-weight="')}"])`;
        }
        $(selectorString).addClass('disabled');
    },
    /**
     * enables all pralines
     */
    enableAddPralines() {
        $('.praline-selector-container .praline-box-single.disabled').removeClass('disabled');
    },
    /**
     * check if pralines are disbaled
     * @returns {boolean} returns if pralines are disabled
     */
    pralinesAreDisable() {
        return $('.praline-selector-container .praline-box-single').hasClass('disabled');
    },
    /**
     * gets the amount of irrestibles in order to fill an irrestibles row
     * @returns {number} amount of irresistibles needed to fill the irrestibles row
     */
    extraIrresistiblesNeeded() {
        const remainder = this.getAmountOfIrresistiblesInBoxArr() % this.boxAmountOfIrresistibles;
        return remainder === 0 ? 0 : this.boxAmountOfIrresistibles - remainder;
    },
    /**
     * check if you need to add cornets to finish box
     * @returns {boolean} returns if you need to add cornets to finish box
     */
    needExtraCornet() {
        return this.getAmountOfCornetsInBoxArr() % 2 === 1;
    },
    /**
     * adds a disabled spot to box, if irrestible is added
    */
    disableSpotWhenIrristibles() {
        if (this.extraIrresistiblesNeeded() === (this.boxAmountOfIrresistibles - 1)) {
            $('.js-selected-content:not(.disabled').last().addClass('disabled');
        }
    },
    /**
     * gets the amount of empty spots in the box
     * @returns {number} amount of empty spots in box
     */
    checkAmountLeft() {
        let amountOfIrresistiblesInBoxArr = this.getAmountOfIrresistiblesInBoxArr();
        // let irresistiblesRemainder = amountOfIrresistiblesInBoxArr > 0 ? this.extraIrresistiblesNeeded(amountOfIrresistiblesInBoxArr) : null;
        if (amountOfIrresistiblesInBoxArr > 0) {
            if (amountOfIrresistiblesInBoxArr < this.boxAmountOfIrresistibles) {
                // if the amount of Irresistibles is less then the max amount per col
                return this.maxAmountOfPralinesPerBox - this.boxArr.length - 1;
            }
            // if the amount of irrestibles in the box is more then 1 col
            return this.maxAmountOfPralinesPerBox - this.boxArr.length - (amountOfIrresistiblesInBoxArr / this.boxAmountOfIrresistibles);
        }
        // if no irrestibles are in the box
        return this.maxAmountOfPralinesPerBox - this.boxArr.length;
    },
    /**
     * disables proceed button
     */
    disableProceedButton() {
        $('.js-proceed-fyob').addClass('disabled');
    },
    /**
     * enables proceed button
     */
    enableProceedButton() {
        $('.js-proceed-fyob').removeClass('disabled');
    },
    /**
     * checks of pralines should be disabled/enabled based on praline logic
     */
    checkToDisableOrEnablePralines() {
        const amountLeft = Math.floor(this.checkAmountLeft());
        const amountOfCol = this.getAmountOfCol();
        const extraNeeded = this.extraIrresistiblesNeeded();
        const needExtraCornet = this.needExtraCornet();

        if (amountLeft === 0) {
            // hide everything because box is full
            this.disableAddPralines();
            this.enableProceedButton();
        }
        // irristibles are not needed and cornets arn't needed
        // only show pralines weight = 1
        if (amountLeft === 1 && extraNeeded === 0 && !needExtraCornet) {
            this.disableAddPralines([1]);
        }

        // only show irristestibles
        if (extraNeeded === amountLeft) {
            this.disableAddPralines([3]);
        }

        // only show cornets
        if (needExtraCornet && amountLeft === 1) {
            this.disableAddPralines([2]);
        }

        // if irristibles are needed and cornets are needed
        if (needExtraCornet && (amountLeft - extraNeeded === 1)) {
            this.disableAddPralines([2, 3]);
        }

        // not enough space for irristibles
        if (extraNeeded === 0 && amountLeft < amountOfCol) {
            this.disableAddPralines([1, 2]);
        }


        if (needExtraCornet && (extraNeeded === 0) && (amountLeft - 1 === this.boxAmountOfIrresistibles)) {
            this.disableAddPralines([1, 2]);
        }

        // if (((amountOfCornets === 1 || amountOfCornets % 2) && amountLeft === 1)) {
        //     // hide everything but the cornets, because you always need to have double cornets
        //     this.disableAddPralines([2]);
        // }
        // // if ((Math.floor(amountLeft) === extraNeeded) && (extraNeeded < amountOfCol)) {
        // if ((Math.floor(amountLeft) === extraNeeded)) {
        //     this.disableAddPralines([3]);
        // }

        // // || (extraNeeded && (amountLeft - extraNeeded < 2))
        // if ((amountLeft === 1 && !(amountOfCornets % 2) && !extraNeeded)) {
        //     // when you have 1 space left
        //     this.disableAddPralines([1]);
        // }

        // if (!extraNeeded && amountLeft < amountOfCol) {
        //     this.disableAddPralines([1, 2]);
        // }

        // if (extraNeeded === 1 && amountLeft === 1) {
        //     // when you need to have a certain amount of irrestibles per row
        //     this.disableAddPralines([3]);
        // }

        // if (extraNeeded === 1 && amountLeft === 2 && (amountOfCornets % 2)) {
        //     this.disableAddPralines([2, 3]);
        // }

        // if (amountLeft === 2 && extraNeeded > 0) {
        //     this.disableAddPralines([2]);
        // }
    },
    /**
     * builds a string of all the pids
     * @returns {string} String array of pids
     */
    getStringArrayOfPids() {
        return this.boxArr.map(function (currentValue) {
            return currentValue.pid.toString();
        }).join(',');
    },
    /**
     * add to cart function
     * @param {string} url url to send to add-to-cart
     */
    addToCart(url) {
        const params = {
            boxPid: $('.js-selected-box').data('pid'),
            selectedIds: this.getStringArrayOfPids()
        };
        const newUrl = urlHelper.appendToUrl(url, params);

        $.ajax({
            url: newUrl,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.js-feedback').removeClass('d-none');
                }
            }
        });
    },
    /**
     * clears the information Modal
     */
    clearModal() {
        $('.js-info-header').empty();
        $('.js-info-description').empty();
        $('.js-allergy-container').hide();
    },
    /**
     * hides or shows information modal
     * @param {Object} element selected element
     */
    showModal(element) {
        const $popupSelector = $('.js-praline-popup');
        $popupSelector.toggleClass('d-none');

        if (!fyobManager.isMobile()) {
            $popupSelector.css({ top: 0, left: 0 });
            let $container = $('.praline-selector-container');
            let containerOffset = $container.offset();
            let elementOffset = $(element).offset();
            let topOffset = elementOffset.top - containerOffset.top;

            if (elementOffset.top > 800) {
                topOffset -= ($popupSelector.height() + 125);
            }
            let relativeOffset = {
                top: topOffset,
                left: elementOffset.left - containerOffset.left
            };

            $popupSelector.css({
                display: 'block',
                top: relativeOffset.top + $(element).outerHeight() + 'px',
                left: relativeOffset.left + 'px'
            });
        }
    },
    /**
     * hides the information modal
     */
    hideModal() {
        const $popupSelector = $('.js-praline-popup');
        $popupSelector.addClass('d-none');
    },
    /**
     * sets the productname as title of modal
     * @param {string} modalName name of selected praline
     */
    setModalName(modalName) {
        $('.js-info-header').text(modalName);
    },
    /**
     * sets the praline description on inforamation description
     * @param {string} modalDescription praline description
     */
    setModalDescription(modalDescription) {
        $('.js-info-description').text(modalDescription);
    },
    /**
     * shows allergies in modal based on praline allergeis
     * @param {arry} allergies array of allergies
     */
    showAllergies(allergies) {
        if (allergies) {
            const allergiesArr = allergies.split(',');
            allergiesArr.forEach(function (allergy) {
                $('.js-allergy-container[data-allergy="' + allergy + '"]').show();
            });
        }
    },
    /**
     * builds the praline info modal
     * @param {array} pralineInfo array of praline info
     * @param {Object} element selected element
     */
    buildPralineInfo(pralineInfo, element) {
        this.clearModal();
        this.setModalName(pralineInfo.productName);
        this.setModalDescription(pralineInfo.description);
        this.showAllergies(pralineInfo.allergies);
        this.showModal(element);
    },
    setupPralineInfo(element) {
        const productInfo = {
            productName: $(element).data('praline-name'),
            description: $(element).data('description'),
            allergies: $(element).data('allergies')
        };
        this.buildPralineInfo(productInfo, element);
    },
    /**
     * sets the amount left on the amount left container above the box
     */
    setAmountLeft() {
        const amountLeft = this.checkAmountLeft();
        $('.js-amount-counter').text(Math.floor(amountLeft));
    },
    /**
     * hide the pralines based on the allergies selected in the filter
     */
    hidePralinesWithAllergy() {
        const allergyArr = [];
        const products = $('.js-praline-selector[data-allergies]:not(.d-none)');

        $('.js-allergy-selector:not(:checked)').each(function (index, element) {
            const allergy = $(element).data('filter');
            allergyArr.push(allergy.toLowerCase());
        });
        const allergyCounter = allergyArr.length;

        if (allergyCounter > 0) {
            $('.js-filter-count[data-type="allergensDropdown"]').removeClass('d-none').addClass('d-inline-block').text(allergyCounter);
            $('.js-filter-count[data-type="collapseAllergies"]').removeClass('d-none').addClass('d-inline-block').text(allergyCounter);
        } else {
            $('.js-filter-count[data-type="allergensDropdown"]').removeClass('d-inline-block').addClass('d-none');
            $('.js-filter-count[data-type="collapseAllergies"]').removeClass('d-inline-block').addClass('d-none');
        }

        if (allergyCounter > 0) {
            products.each(function () {
                const allergiesSelector = $(this).data('allergies') ? $(this).data('allergies').toLowerCase() : '';
                if (allergiesSelector) {
                    let allergies = allergiesSelector.split(',').map(allergy => allergy.trim());

                    const hasMatchingAllergy = allergyArr.some(selectedAllergy =>
                        allergies.includes(selectedAllergy.trim().toLowerCase())
                    );
                    if (hasMatchingAllergy) {
                        $(this).removeClass('d-flex').addClass('d-none');
                    } else {
                        $(this).removeClass('d-none').addClass('d-flex');
                    }
                }
            });
        }
    },
    updateFilterCounter(arr) {
        // filling
        const fillingCounter = arr.filter(item => item.option === 'filling').length;
        if (fillingCounter > 0) {
            $('.js-filter-count[data-type="fillingDropdown"]').removeClass('d-none').addClass('d-inline-block').text(fillingCounter);
            $('.js-filter-count[data-type="collapseFilling"]').removeClass('d-none').addClass('d-inline-block').text(fillingCounter);
        } else {
            $('.js-filter-count[data-type="fillingDropdown"]').removeClass('d-inline-block').addClass('d-none');
            $('.js-filter-count[data-type="collapseFilling"]').removeClass('d-inline-block').addClass('d-none');
        }

        // type
        const typeCounter = arr.filter(item => item.option === 'type').length;
        if (typeCounter > 0) {
            $('.js-filter-count[data-type="typeDropdown"]').removeClass('d-none').addClass('d-inline-block').text(typeCounter);
            $('.js-filter-count[data-type="collapseType"]').removeClass('d-none').addClass('d-inline-block').text(typeCounter);
        } else {
            $('.js-filter-count[data-type="typeDropdown"]').removeClass('d-inline-block').addClass('d-none');
            $('.js-filter-count[data-type="collapseType"]').removeClass('d-inline-block').addClass('d-none');
        }
    },
    showPralinesWithType() {
        const typeArr = [];
        const products = $('.js-praline-selector');

        $('.js-filter-selector:checked').each(function (index, element) {
            const type = $(element).data('filter');
            if (type) {
                typeArr.push({
                    filter: type.toLowerCase(),
                    option: $(element).data('filter-option')
                });
            }
        });
        this.updateFilterCounter(typeArr);

        const groupedFilters = this.filterArr.reduce((acc, filter) => {
            if (!acc[filter.name]) {
                acc[filter.name] = [];
            }
            acc[filter.name].push(filter.value);
            return acc;
        }, {});

        products.each(function (index, product) {
            if (typeArr.length === 0) {
                $(product).removeClass('d-none').addClass('d-flex');
            } else {
                const product = $(this);

                let matches = true;

                if (groupedFilters.type && groupedFilters.filling) {
                    const typeMatches = groupedFilters.type.includes(product.data('type'));
                    const fillingMatches = groupedFilters.filling.includes(product.data('filling'));

                    if (!(typeMatches && fillingMatches)) {
                        matches = false;
                    }
                } else {
                    // If only one of the filters exists, handle separately
                    for (const [key, values] of Object.entries(groupedFilters)) {
                        if (!values.includes(product.data(key))) {
                            matches = false; // Disqualify if key doesn't match any value
                            break;
                        }
                    }
                }

                if (matches) {
                    product.removeClass('d-none').addClass('d-flex');
                } else {
                    product.removeClass('d-flex').addClass('d-none');
                }
            }
        });
    },
    updateSelectedFilters() {
        this.showPralinesWithType();
        this.hidePralinesWithAllergy();
    },
    showAllPralines() {
        const hiddenProducts = $('.js-praline-selector.d-none');

        hiddenProducts.each(function () {
            $(this).removeClass('d-none').addClass('d-flex');
        });
    },
    showSpecialMsg(pralineWeight) {
        const $msgSelector = $('.js-special-msg');
        const $content = $msgSelector.data(`weight-${pralineWeight}`);
        $msgSelector.text($content);
        $msgSelector.show();

        setTimeout(function () {
            $msgSelector.fadeOut(1000);
        }, 3500);
    },
    // addFilterLabel(filterArr) {
    //     const $filterSelector = $('.js-filter-container');
    //     $filterSelector.append(
    //         `<span class="badge badge-custom-filter d-inline-block mx-1 js-remove-filter-badge py-2 px-4"
    //              data-filter="${filterArr.value}">
    //              ${filterArr.value}
    //              <span class="remove-filter" aria-hidden="true">×</span>
    //         </span>`);
    // },
    addFilterToArr(filterName, filterValue) {
        const filterArr = {
            name: filterName,
            value: filterValue
        };

        this.filterArr.push(filterArr);
        // this.addFilterLabel(filterArr);
    },
    removeFilterFromArr(filterName) {
        const index = this.filterArr.findIndex(function (filter) {
            return filter.value.toLowerCase() === filterName.toLowerCase();
        });

        if (index > -1) {
            this.filterArr.splice(index, 1);
        }
    },
    clearFilterArr() {
        this.filterArr = [];
    },
    handleRemovePraline(element) {
        const boxPlace = ($(element).data('box-place'));
        fyobManager.removeSelectedBoxSpot(boxPlace);
        fyobManager.setAmountLeft();
    },
    scrollContainer() {
        if (this.isMobile() && $('.praline-search-panel').length) {
            const $container = document.querySelector('.js-scroll-container');
            const $target = document.querySelector('.js-scroll-container .box-title-container');

            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 1
            };

            const callback = (entries) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) {
                        $target.classList.add('fixed-container');
                    } else if (entry.isIntersecting) {
                        $target.classList.remove('fixed-container');
                    }
                });
            };
            const observer = new IntersectionObserver(callback, options);

            observer.observe($container);
        }
    },
    showPralineAddedNotifcation() {
        if (this.isMobile()) {
            const $msgSelector = $('.js-added-notification');
            $msgSelector.show();

            setTimeout(function () {
                $msgSelector.fadeOut(400);
            }, 500);
        }
    },
    setHeightBasedOnBox() {
        if (!this.isMobile()) {
            const heightOfBox = $('.js-box-height-container').height();

            if (heightOfBox > 720) {
                $('.praline-selector-container').css('max-height', heightOfBox);
            }
        }
    }
};

$(document).ready(function () {
    fyobManager.getIrresistiblesAmount();
    fyobManager.getAmountOfPralinesPerBox();
    fyobManager.setAmountLeft();
    fyobManager.scrollContainer();
    fyobManager.setHeightBasedOnBox();
    $('.js-fyob-proceed').on('click', function (e) {
        e.preventDefault();
        let selectedProductId = $(this).data('product-id');
        if (selectedProductId) {
            $('.js-error-msg').addClass('d-none');
            const redicrecturl = $(this).data('href');
            window.location.replace(redicrecturl + '?fyodpid=' + selectedProductId);
        } else {
            $('.js-error-msg').removeClass('d-none');
        }
    });

    $('.js-praline-selector').on('click', function () {
        if (!$(this).closest('.js-praline-selector').hasClass('disabled')) {
            const productData = {
                pid: $(this).data('pid'),
                productWeight: $(this).data('praline-weight'),
                productImage: $(this).closest('.js-praline-selector').find('.js-praline-image').attr('src'),
                productName: $(this).closest('.js-praline-selector').find('.js-praline-name').text()
                .trim()
            };
            fyobManager.pushDataIntoArray(productData);
            if (productData.productWeight === 3) {
                fyobManager.disableSpotWhenIrristibles();
            }

            if (productData.productWeight === 3 || productData.productWeight === 2) {
                fyobManager.showSpecialMsg(productData.productWeight);
            }
            if (!$('.js-praline-popup').hasClass('d-none')) {
                fyobManager.hideModal();
            }
            fyobManager.showPralineAddedNotifcation();
            fyobManager.buildBoxGridBasedOnArray();
            fyobManager.setAmountLeft();
            fyobManager.checkToDisableOrEnablePralines();
        }
    });

    $('.js-selected-content').on('click', function (e) {
        e.preventDefault();
        fyobManager.handleRemovePraline(this);
    });

    $('.js-praline-search').on('keyup', function () {
        const searchText = $(this).val();
        const products = $('.js-praline-selector');

        fyobManager.productSearch(searchText, products);
        fyobManager.productRemainingMsg();
    });

    $('.js-proceed-fyob').on('click', function (e) {
        e.preventDefault();
        const url = $(this).attr('href');
        fyobManager.addToCart(url);
    });

    $('.js-praline-info').on('click', function (e) {
        if (fyobManager.isMobile()) {
            e.stopPropagation();
            fyobManager.setupPralineInfo(this);
        }
    });

    $('.js-praline-info').on('mouseover', function (e) {
        if (!fyobManager.isMobile()) {
            e.stopPropagation();
            fyobManager.setupPralineInfo(this);
        }
    });

    $('.js-praline-info').on('mouseleave', function () {
        if (!fyobManager.isMobile()) {
            fyobManager.hideModal();
        }
    });

    $('.js-praline-info-close').on('click', function () {
        fyobManager.hideModal();
    });

    $(document).on('keyup', function (evt) {
        if (evt.keyCode === 27) { // escape
            fyobManager.hideModal();
        }
    });

    $('.js-allergy-selector').on('change', function (e) {
        const selectedAllergy = $(e.currentTarget).data('filter');

        if (!e.target.checked) {
            fyobManager.removeFilterFromArr(selectedAllergy);
        }
        fyobManager.updateSelectedFilters();
    });

    $('.js-filter-selector').on('change', function (e) {
        const selectedType = $(e.currentTarget).data('filter');
        const selectedFilterOption = $(e.currentTarget).data('filter-option');
        if (e.target.checked) {
            fyobManager.addFilterToArr(selectedFilterOption, selectedType);
        } else {
            fyobManager.removeFilterFromArr(selectedType);
        }

        fyobManager.updateSelectedFilters();
    });

    $('.js-reset-filters').on('click', function (e) {
        e.preventDefault();
        $('.js-allergy-selector').prop('checked', true);
        $('.js-filter-selector').prop('checked', false);
        fyobManager.showAllPralines();
        fyobManager.clearFilterArr();
        fyobManager.updateSelectedFilters();
    });

    $('.dropdown-item').on('click', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', '.js-remove-filter-badge', function (e) {
        const filter = $(e.currentTarget).data('filter');
        $('[data-filter="' + filter + '"]:checked').prop('checked', false);

        fyobManager.removeFilterFromArr(filter);
        fyobManager.updateSelectedFilters();
        $(this).remove();
    });

    $('#collapsibleContent').on('shown.bs.collapse', function () {
        $('.js-collapse-icon[data-collapsed=true]').show();
        $('.js-collapse-icon[data-collapsed=false]').hide();
    });

    $('#collapsibleContent').on('hide.bs.collapse', function () {
        $('.js-collapse-icon[data-collapsed=false]').show();
        $('.js-collapse-icon[data-collapsed=true]').hide();
    });

    $('.dropdown-toggle').on('click', function (e) {
        if ($(`.dropdown-content#${$(this).attr('aria-controls')}`).hasClass('show')) {
            e.stopPropagation();
            $(`.dropdown-content#${$(this).attr('aria-controls')}`).removeClass('show');
        }
        $('.filter-container .collapse.show').removeClass('show');

        const id = $(this).attr('id');
        $(`.dropdown-menu.show:not([aria-labelledby=${id}])`).removeClass('show');
        $(`.dropdown-menu[aria-labelledby=${id}]`).toggleClass('show');
    });

    $('.js-fyob-tile').on('click', function () {
        $(this).find('.js-box-selector').prop('checked', true);
    });
});
